/*** IMPORTS FROM imports-loader ***/
(function() {

define([
    'jquery',
    'mustache',
    'pip-model',
    'plugin.tooltip',
    'pip-events',
    'window',
    'breakpoints'
  ],
  function subscribeAndSaveAddOn(
    $,
    Mustache,
    pip,
    tooltip,
    pipEvents,
    window,
    breakpoints
  ) {
    var DISCOUNT_VALUE = 0.95; // 5% off from 100%

    var FREQUENCY_MAP = {
      1: '1_3',
      2: '2_3',
      3: '3_3',
      4: '4_3',
      5: '5_3',
      6: '6_3',
      12: '12_3'
    };

    var NO_FREQUENCY = '0_0';

    var helperMethods = {
      isSubscribeAndSaveDisplayable: function isSubscribeAndSaveDisplayable() {
        var hasOgOffer = !!document.querySelector(view.selectors.ogWidget);

        return !!(hasOgOffer
          && pip.features.subscribeAndSaveFeature.isEnabled
          && pip.subscribeAndSaveEligible
          && pip.fulfillment
          && pip.fulfillment.shipping
          && pip.fulfillment.shipping.shipToHome
          && pip.products
          && pip.products.primary
          && pip.products.primary.data
          && pip.products.primary.data.itemExtension
          && pip.products.primary.data.itemExtension.pricing
          && (pip.products.primary.data.itemExtension.pricing.originalPrice
            || pip.products.primary.data.itemExtension.pricing.specialPrice));
      },

      isPriceSwapEligibleExperience: function isPriceSwapEligibleExperience() {
        if (!pip.features.strikeThruPricingForTntEnabled) {
          return false;
        }

        var pricingRegularDiv = $(view.selectors.buyboxPricingRegular);
        var hasRegularPrice = pricingRegularDiv.length;
        var newLowerPriceDiv = $(view.selectors.buyboxStrikeThruPricingWrapper);
        var pricingDivInnerText = hasRegularPrice ? pricingRegularDiv[0].innerText : '';
        var isPriceOverOneDollar = pricingDivInnerText.indexOf('$') !== -1;
        var hasNewLowerPriceText = newLowerPriceDiv.length ? newLowerPriceDiv[0].innerText : '';

        return hasRegularPrice
          && isPriceOverOneDollar
          && !hasNewLowerPriceText;
      },

      /**
       * * to make the strike thru pricing TnT experience permanent,
       * remove this function and all references to it
       * @returns boolean
       */
      hasTntStrikeThruPriceEnablingElement: function hasTntStrikeThruPriceEnablingElement(){
        return $(view.selectors.tntStrikeThruPriceEnablingElement).length > 0;
      },

      handleError: function newRelicHandleError(err) {
        if (pip.debugMode) {
          /* eslint-disable-next-line no-console */
          console.log('ERROR: pip-subscribe_and_save', err);
        }

        if (typeof window.newrelic === 'object' && window.newrelic.noticeError && window.newrelic.addPageAction) {
          window.newrelic.addPageAction('JSError', {
            'errorSourceFile': 'pip-subscribe_and_save',
            'errorType': err.name,
            'errorMessage': err.message,
            'errorStack': err.stack
          });
          window.newrelic.noticeError(err);
        }
      },

      orderGroove: {
        getProductData: function getOrderGrooveProductData() {
          return {
            id: pip.products.primary.data.itemId,
            module: 'pdp_nocontent',
            quantity: typeof pip.customer.quantity !== 'undefined' ? pip.customer.quantity : 1
          };
        },

        setFrequency: function setOrderGrooveFrequency() {
          window.OG.API(
            'pdp_nocontent',
            pip.products.primary.data.itemId,
            'setFrequency',
            pip.customer.subscriptions.frequency
          );
        },

        ogInitObserver: function initOrderGrooveObserver() {
          var observer = new MutationObserver(setOgFrequency);
          var orderGrooveDiv = document.querySelector(view.selectors.ogWidget);
          function setOgFrequency() {
            helperMethods.orderGroove.setFrequency();
            observer.disconnect();
          }
          observer.observe(orderGrooveDiv, {childList: true});
        },

        init: function initOrderGroove() {
          try {
            helperMethods.orderGroove.ogInitObserver();
            window.OG.setProduct(helperMethods.orderGroove.getProductData());
            window.OG.setQuantity(helperMethods.orderGroove.getProductData());
          } catch (err) {
            helperMethods.handleError(err);
          }
        },

        update: function updateOrderGroove() {
          try {
            window.OG.setQuantity(helperMethods.orderGroove.getProductData());
            helperMethods.orderGroove.setFrequency();
          } catch (err) {
            helperMethods.handleError(err);
          }
        },

        ATC: function orderGrooveAddToCart() {
          try {
            window.OG.updateCart([helperMethods.orderGroove.getProductData()]);
          } catch (err) {
            helperMethods.handleError(err);
          }
        }
      }
    };


    var view = {
      templates: {
        options: $('#subscribe-and-save-options-js').html(),
        message: $('#subscribe-and-save-message-js').html(),
        frequency: $('#subscribe-and-save-frequency-js').html(),
        tooltip: $('#subscribe-and-save-tooltip-js').html(),
        buyboxStrikeThruPrice: $('#subscribe-and-save-strike-thru-price-js').html()
      },

      selectors: {
        subscribeAndSave: 'subscribe-and-save',
        subscribeAndSaveHidden: 'subscribe-and-save--hidden',
        widget: '#subscribe-and-save',
        ogWidget: '.og-offer',
        options: '#subscribe-and-save-options',
        radio: 'input[type=radio][name=subscribe-and-save-radio]',
        optInRadio: '#subscribe-and-save-options__opt-in',
        optInRadioId: 'subscribe-and-save-options__opt-in',
        optOutRadio: '#subscribe-and-save-options__opt-out',
        message: '#subscribe-and-save-message',
        frequency: '#subscribe-and-save-frequency',
        frequencyDropDown: '#subscribe-and-save-frequency__select',
        tooltip: '#subscribe-and-save-tooltip',
        learnMore: '#subscribe-and-save-message__learn-more',
        buyboxPricingRegular: '.pricingRegular',
        buyboxStrikeThruPricingWrapper: '.buybox_pricing_saving.js-uom',
        tntStrikeThruPriceEnablingElement: 'input#tntStrikeThruPriceEnablingElement[type="hidden"]'
      },

      eventClasses: {
        subscribeAndSave: '.subscribeAndSave',
        changeSubscribeAndSave: 'change.subscribeAndSave'
      },

      init: function initSubscribeAndSaveView() {
        view.updateDOM.subscribeAndSave();
        view.initEventListeners();
        view.showSubscribeAndSave();
        view.updateSubscriptionView();
      },

      render: {
        options: function renderOptions() {
          return Mustache.render(view.templates.options, viewModel);
        },
        message: function renderMessage() {
          return Mustache.render(view.templates.message, viewModel);
        },
        frequency: function renderFrequency() {
          return Mustache.render(view.templates.frequency, viewModel);
        },
        tooltip: function renderTooltip() {
          return Mustache.render(view.templates.tooltip, viewModel);
        },
        buyboxStrikeThruPrice: function renderBuyboxStrikeThruPrice() {
          return Mustache.render(view.templates.buyboxStrikeThruPrice, viewModel);
        }
      },

      updateDOM: {
        subscribeAndSave: function updateSubscribeAndSaveDom() {
          $(view.selectors.options).html(view.render.options);
          $(view.selectors.message).html(view.render.message);
          $(view.selectors.frequency).html(view.render.frequency);
          $(view.selectors.tooltip).html(view.render.tooltip);
        }
      },

      updateSubscriptionView: function updateSubscribeAndSaveView() {
        $(view.selectors.optInRadio).prop('checked', pip.customer.subscriptions.isOptedIn);
        $(view.selectors.optOutRadio).prop('checked', !pip.customer.subscriptions.isOptedIn);
        var frequencyValue = pip.customer.subscriptions.frequency.split('_')[0] || '0';
        if (frequencyValue !== '0') {
          $(view.selectors.frequencyDropDown).val(frequencyValue);
        }

        if (viewModel.isPriceSwapEligibleExperience && helperMethods.hasTntStrikeThruPriceEnablingElement()) {
          var buyboxPriceStyle = pip.customer.subscriptions.isOptedIn
            ? viewModel.strikeThruBuyboxPrice
            : viewModel.originalBuyboxPrice;
          $(view.selectors.buyboxPricingRegular).html(buyboxPriceStyle);
        }
      },

      showSubscribeAndSave: function showSubscribeAndSave() {
        $(view.selectors.widget).toggleClass(view.selectors.subscribeAndSave + ' ' + view.selectors.subscribeAndSaveHidden);
      },

      initTooltipListener: function initSubscribeAndSaveTooltipListener() {
      
      var tooltipOptions = {
        type: 'click',
        position: 'bottom',
        content: view.templates.tooltip,
        width: breakpoints.isActiveBreakpointEqualToOrSmallerThan('Small') ? 'medium' : 'large',
        closeButton: true,
        bestPosition: false,
        closeOnClick: true
      };
      $(view.selectors.learnMore).tooltip(tooltipOptions);
    },
  

      initRadioListener: function initSubscribeAndSaveRadioListener() {
        var radios = $(view.selectors.radio);
        radios.off(view.eventClasses.subscribeAndSave);
        radios.on(view.eventClasses.changeSubscribeAndSave, function (event) {
          pip.customer.subscriptions.isOptedIn = (event.target.id === view.selectors.optInRadioId);
          pip.customer.subscriptions.frequency = pip.customer.subscriptions.isOptedIn
            ? viewModel.getOgFrequencyFromValue($(view.selectors.frequencyDropDown).val())
            : NO_FREQUENCY;
          helperMethods.orderGroove.update();
          pipEvents.customer.customerSubscriptionStateChanged.trigger({fromSubAndSave: true});
          view.updateSubscriptionView();
        });
      },

      initFrequencyStateListener: function initSubscribeAndSaveFrequencyStateListener() {
        var frequencySelect = $(view.selectors.frequencyDropDown);
        frequencySelect.off(view.eventClasses.subscribeAndSave);
        frequencySelect.on(view.eventClasses.changeSubscribeAndSave, function () {
          pip.customer.subscriptions.isOptedIn = true;
          pip.customer.subscriptions.frequency = viewModel.getOgFrequencyFromValue(frequencySelect.val());
          helperMethods.orderGroove.update();
          pipEvents.customer.customerSubscriptionStateChanged.trigger({fromSubAndSave: true});
          view.updateSubscriptionView();
        });
      },

      initSubscriptionStateChangedListener: function initSubscribeAndSaveStateChangedListener() {
        pipEvents.customer.customerSubscriptionStateChanged.off(view.eventClasses.subscribeAndSave);
        pipEvents.customer.customerSubscriptionStateChanged.on(view.eventClasses.subscribeAndSave, function (type, data) {
          if (!data || !data.fromSubAndSave) {
            pip.customer.subscriptions.frequency = pip.customer.subscriptions.isOptedIn
              ? pip.customer.subscriptions.frequency
              : NO_FREQUENCY;
            view.updateSubscriptionView();
            helperMethods.orderGroove.update();
          }
        });
      },

      initQuantityChangedListener: function initSubscribeAndSaveQuantityChangedListener() {
        pipEvents.pipModel.pipModelQuantityUpdated.off(view.eventClasses.subscribeAndSave);
        pipEvents.pipModel.pipModelQuantityUpdated.on(view.eventClasses.subscribeAndSave, function () {
          helperMethods.orderGroove.update();
        });
      },

      initAddToCartListener: function initSubscribeAndSaveAddToCartListener() {
        pipEvents.cart.subscribe.off(view.eventClasses.subscribeAndSave);
        pipEvents.cart.subscribe.on(view.eventClasses.subscribeAndSave, function () {
          helperMethods.orderGroove.ATC();
        });
      },

      initEventListeners: function initSubscribeAndSaveEventListeners() {
        view.initTooltipListener();
        view.initRadioListener();
        view.initFrequencyStateListener();
        view.initSubscriptionStateChangedListener();
        view.initQuantityChangedListener();
        view.initAddToCartListener();
      }
    };


    var viewModel = {
      frequencyMaps: [
        {
          homeDepotValue: '1',
          text: '1 Month'
        },
        {
          homeDepotValue: '2',
          text: '2 Months'
        },
        {
          homeDepotValue: '3',
          text: '3 Months'
        },
        {
          homeDepotValue: '4',
          text: '4 Months'
        },
        {
          homeDepotValue: '5',
          text: '5 Months'
        },
        {
          homeDepotValue: '6',
          text: '6 Months'
        },
        {
          homeDepotValue: '12',
          text: '12 Months'
        }
      ],

      getOgFrequencyFromValue: function getOgFrequencyFromValue(frequencyValue) {
        return frequencyValue ? FREQUENCY_MAP[frequencyValue] : NO_FREQUENCY;
      },

      initFrequencyMaps: function initSubscribeAndSaveFrequencyMaps() {
        var FALLBACK_DEFAULT_FREQUENCY = '6';
        viewModel.defaultFrequency = pip.products.primary.data.itemExtension.subscriptionDefaultFrequency
          ? pip.products.primary.data.itemExtension.subscriptionDefaultFrequency
          : FALLBACK_DEFAULT_FREQUENCY;
        viewModel.frequencyMaps.forEach(function (frequency) {
          frequency.isDefault = frequency.homeDepotValue === viewModel.defaultFrequency;
        });
      },

      saveAndRenderPriceDisplays: function saveAndRenderPriceDisplays() {
        viewModel.originalBuyboxPrice = $(view.selectors.buyboxPricingRegular).html();
        viewModel.strikeThruBuyboxPrice = view.render.buyboxStrikeThruPrice();
      },

      setPricingInfo: function setPricingInfo() {
        var pricing = pip.products.primary.data.itemExtension.pricing;
        var displayPrice;
        var discountPrice;

        if (viewModel.isPriceSwapEligibleExperience){
          displayPrice = (pricing.specialPrice ? pricing.specialPrice : pricing.originalPrice).toFixed(2);
          discountPrice = (DISCOUNT_VALUE * displayPrice).toFixed(2);
          viewModel.discountAmount = (displayPrice - discountPrice).toFixed(2);
          viewModel.originalDollarsPrice = displayPrice.split('.')[0];
          viewModel.originalCentsPrice = displayPrice.split('.')[1];
        } else {
          displayPrice = pricing.specialPrice ? pricing.specialPrice : pricing.originalPrice;
          discountPrice = (DISCOUNT_VALUE * displayPrice).toFixed(2);
        }

        viewModel.dollarsPrice = discountPrice.split('.')[0];
        viewModel.centsPrice = discountPrice.split('.')[1];
      },

      init: function initSubscribeAndSaveViewModel() {
        viewModel.isPriceSwapEligibleExperience = helperMethods.isPriceSwapEligibleExperience();
        viewModel.initFrequencyMaps();
        viewModel.setPricingInfo();
        viewModel.saveAndRenderPriceDisplays();
        if (viewModel.isPriceSwapEligibleExperience) {

        }
      }
    };


    var model = {
      init: function initSubscribeAndSaveModel() {
        pip.customer.subscriptions = pip.customer.subscriptions || {};
        pip.customer.subscriptions.frequency = pip.customer.subscriptions.frequency || NO_FREQUENCY;
        pip.customer.subscriptions.isOptedIn = !!pip.customer.subscriptions.isOptedIn; // default subscription state
        helperMethods.orderGroove.init();
        pipEvents.customer.customerSubscriptionStateChanged.trigger({fromSubAndSave: true});
      }
    };

    return {
      init: function initSubscribeAndSave() {
        try {
          if (helperMethods.isSubscribeAndSaveDisplayable()) {
            window.og_settings = {
              "page_type": "1"
            };
            $.ajax({
              dataType: "script",
              cache: true,
              url: "https://" + pip.features.subscribeAndSaveFeature.hostName + "/379dc8f09a4311e7806bbc764e106cf4/main.js"
            }).done(function () {
              model.init();
              viewModel.init();
              view.init();
            });
          }
        } catch (err) {
          helperMethods.handleError(err);
        }
      },
      view: view,
      viewModel: viewModel,
      model: model
    }
  });

}.call(window));